/**
 * CustomerMetrics - Customer & Growth Metrics section
 */
import React from 'react';
import { TrendingUp, UserX, UserCheck, Target, Activity } from 'lucide-react';
import { MetricCard, MetricSection, MetricGrid } from '../MetricCard';
import { formatValue } from '../analyticsFormatters';

export function CustomerMetrics({ snapshotData }) {
  const summary = snapshotData?.summary || {};
  
  return (
    <MetricSection title="Customer & Growth Metrics">
      <MetricGrid cols={4}>
        <MetricCard
          icon={TrendingUp}
          iconColor="bg-purple-100 dark:bg-purple-900/20"
          title="Average LTV"
          value={formatValue(summary.averageLTV || 0, 'currency')}
          subtitle="Per customer lifetime"
          subtitleColor="text-purple-600 dark:text-purple-400"
        />
        <MetricCard
          icon={UserX}
          iconColor="bg-red-100 dark:bg-red-900/20"
          title="Churn Rate"
          value={formatValue(summary.churnRate || 0, 'percentage')}
          subtitle={`${formatValue(summary.churnedUsers || 0, 'number')} churned users`}
          subtitleColor="text-red-600 dark:text-red-400"
        />
        <MetricCard
          icon={UserCheck}
          iconColor="bg-green-100 dark:bg-green-900/20"
          title="Customer Retention"
          value={formatValue(100 - (summary.churnRate || 0), 'percentage')}
          subtitle={`${formatValue(summary.payingCustomers || 0, 'number')} active customers`}
          subtitleColor="text-green-600 dark:text-green-400"
        />
        <MetricCard
          icon={Target}
          iconColor="bg-emerald-100 dark:bg-emerald-900/20"
          title="Trial Conversion"
          value={formatValue(summary.trialToPayConversionRate || 0, 'percentage')}
          subtitle="of trial users converted"
        />
        <MetricCard
          icon={Activity}
          iconColor="bg-blue-100 dark:bg-blue-900/20"
          title="Daily Active Users"
          value={formatValue(summary.dailyActiveUsers || 0, 'number')}
          subtitle="last 24 hours"
        />
      </MetricGrid>
    </MetricSection>
  );
}

